import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
export function CostSection() {
  const costs = [{
    situation: 'Noches buscando resúmenes con errores',
    cost: 'Tiempo perdido + puntos perdidos en el parcial'
  }, {
    situation: 'Sin simulacros',
    cost: 'Parálisis ante la hoja en blanco'
  }, {
    situation: 'Sin sistema de repaso',
    cost: 'Olvidás el 70% antes del examen'
  }, {
    situation: 'Sin planner',
    cost: 'Pánico cuando el parcial es en 48 horas'
  }, {
    situation: 'El mismo ciclo el próximo cuatrimestre',
    cost: 'Otra vez.'
  }];
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-52">
      <FadeIn data-id="element-53">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-54">
          <span className="text-4xl" data-id="element-55">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden" data-id="element-56">
          <div className="grid grid-cols-2 bg-gray-800/80 border-b border-gray-700 p-4 font-bold" data-id="element-57">
            <div className="text-gray-400" data-id="element-58">Sin MegaPack</div>
            <div className="text-red-400" data-id="element-59">Costo real</div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-60">
            {costs.map((item, index) => <div key={index} className="grid grid-cols-2 p-4 items-center hover:bg-gray-800/30 transition-colors" data-id="element-61">
                <div className="text-gray-300 pr-4" data-id="element-62">{item.situation}</div>
                <div className="font-bold text-red-400 flex items-center gap-2" data-id="element-63">
                  <AlertOctagon size={16} className="shrink-0" data-id="element-64" />
                  <span data-id="element-65">{item.cost}</span>
                </div>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}